import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DeleteOutlined,
  DislikeOutlined,
  EditOutlined,
  LikeOutlined,
  MessageOutlined,
  PlusOutlined,
  PrinterOutlined,
  SendOutlined,
  StopOutlined
} from '@ant-design/icons';
import { Button as BtnAntd } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { type CSSProperties } from 'react';
import { LocationCheckIcon, TruckStartIcon } from 'src/assets/icons';
import Icon from '../Icon';

type TypeButton =
  | 'approve'
  | 'accept'
  | 'reject'
  | 'cancelTicket'
  | 'cancelApproval'
  | 'edit'
  | 'delete'
  | 'duplicate'
  | 'handle'
  | 'addSolution'
  | 'updateSolution'
  | 'completedHandle'
  | 'rejectHandle'
  | 'satisfaction'
  | 'unsatisfaction'
  | 'confirm'
  | 'noConfirm'
  | 'addTicketRelate'
  | 'print'
  | 'chat'
  | 'driverConfirmStart'
  | 'driverConfirmEnd';

interface Props {
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  className?: string;
  style?: CSSProperties | undefined;
  type?: TypeButton;
  size?: SizeType;
  content?: string;
  disabled?: boolean;
  isLoading?: boolean;
  stepCancelApproval?: number;
}

const BtnCustom = ({
  type = 'approve',
  size = 'small',
  disabled,
  style,
  content,
  className,
  onClick,
  isLoading,
  stepCancelApproval
}: Props) => {
  const buttonConfigs = {
    handle: { icon: <SendOutlined />, color: 'var(--color-action-approve)', text: 'Xử lý' },
    chat: { icon: <MessageOutlined />, color: '#ed972b', text: 'Chat room' },
    addSolution: { icon: <PlusOutlined />, type: 'primary', text: 'Giải pháp' },
    updateSolution: { icon: <EditOutlined />, type: 'primary', text: 'Giải pháp' },
    completedHandle: { icon: <CheckOutlined />, color: 'var(--color-action-approve)', text: 'Đã xử lý' },
    rejectHandle: { icon: <CloseOutlined />, color: 'var(--color-action-reject)', text: 'Từ chối xử lý' },
    satisfaction: { icon: <LikeOutlined />, color: 'var(--color-action-approve)', text: 'Hài lòng' },
    unsatisfaction: { icon: <DislikeOutlined />, color: 'var(--color-action-reject)', text: 'Không hài lòng' },
    confirm: { icon: <CheckOutlined />, color: 'var(--color-action-approve)', text: 'Xác nhận' },
    noConfirm: { icon: <CloseOutlined />, color: 'var(--color-action-reject)', text: 'Không xác nhận' },
    approve: { icon: <CheckOutlined />, color: 'var(--color-action-approve)', text: 'Phê duyệt' },
    accept: { icon: <CheckOutlined />, color: 'var(--color-action-accept)', text: 'Tiếp nhận' },
    reject: { icon: <CloseOutlined />, color: 'var(--color-action-reject)', text: 'Từ chối' },
    cancelApproval: {
      icon: <StopOutlined />,
      color: 'var(--color-action-cancel)',
      text: `Thu hồi phê duyệt (${stepCancelApproval})`
    },
    cancelTicket: { icon: <StopOutlined />, color: 'var(--color-action-cancel)', text: 'Hủy phiếu' },
    edit: { icon: <EditOutlined />, color: 'var(--color-action-edit)', text: 'Chỉnh sửa' },
    delete: { icon: <DeleteOutlined />, color: 'var(--color-action-delete)', text: 'Xóa phiếu' },
    duplicate: { icon: <CopyOutlined />, type: 'primary', text: 'Sao chép phiếu' },
    addTicketRelate: { icon: <PlusOutlined />, type: 'primary', text: 'Phiếu liên quan' },
    print: { icon: <PrinterOutlined />, type: 'primary', text: 'In phiếu' },
    driverConfirmStart: {
      icon: <Icon url={TruckStartIcon} size={20} />,
      color: 'var(--color-action-edit)',
      text: 'Bắt đầu di chuyển'
    },
    driverConfirmEnd: {
      icon: <Icon url={LocationCheckIcon} size={16} />,
      color: 'var(--color-action-approve)',
      text: 'Xác nhận hoàn thành'
    }
  };

  const config = buttonConfigs[type] || {};
  const { icon, color = '', text, type: buttonType } = config as any;

  return (
    <BtnAntd
      size={size}
      disabled={disabled}
      icon={icon}
      loading={isLoading}
      type={buttonType}
      style={{
        color: color || '',
        borderColor: color || '',
        ...style
      }}
      className={className}
      onClick={onClick}
    >
      {content || text}
    </BtnAntd>
  );
};

export default BtnCustom;
